<div class="navigation-container">
  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav
      #drawer
      class="sidenav"
      fixedInViewport
      [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
      [mode]="(isHandset$ | async) ? 'over' : 'side'"
      [opened]="(isHandset$ | async) === false"
      >
      <mat-toolbar>GMV</mat-toolbar>
      <mat-nav-list>
        @for (route of routes; track route) {
          @if (route.data?.title) {
            <a
              mat-list-item
              [routerLink]="[route.path]"
              >
              <mat-icon matListItemIcon>{{ route.data?.icon }}</mat-icon>
              {{ route.data?.title ?? route.path }}
            </a>
          }
        }
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content>
      <mat-toolbar color="primary">
        @if (isHandset$ | async) {
          <button
            type="button"
            aria-label="Toggle sidenav"
            mat-icon-button
            (click)="drawer.toggle()"
            >
            <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
          </button>
        }
        <span>{{ titleService.getTitle() }}</span>
        <div class="logout">
          <span (click)="logout()" (keydown.enter)="logout()">
            <mat-icon aria-label="Side nav toggle icon">logout</mat-icon>
            <div>Log out</div>
          </span>
        </div>
      </mat-toolbar>
      <div class="scrollable-content">
        <router-outlet></router-outlet>

      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
  <app-footer class="footer-content"></app-footer>
  <app-spinner></app-spinner>
</div>
